import { feedStyles } from "./forum-feed.styles";
import { Fragment } from "react";
import * as stylex from "@stylexjs/stylex";
import { Alert } from "@softmax/design-system";
import { styles } from "../forum.styles";
import { VoteButton } from "../forum-vote-button";
import { Byline } from "../forum-byline";
import type {
  ForumPostRecord,
  ForumVote,
  ForumLinkRenderer,
} from "../forum.types";
function postExcerpt(body: string) {
  return body
    .replace(/```[\s\S]*?```/g, " ")
    .replace(/`([^`]+)`/g, "$1")
    .replace(/!\[[^\]]*\]\([^)]*\)/g, " ")
    .replace(/\[([^\]]*)\]\([^)]*\)/g, "$1")
    .replace(/^\s{0,3}(#{1,6}|>|[-*+]|\d+\.)\s+/gm, "")
    .replace(/[*_~]{1,3}([^*_~]+)[*_~]{1,3}/g, "$1")
    .replace(/\s+/g, " ")
    .trim();
}
function contentExcerpt(content: ForumPostRecord["content"]): string {
  switch (content.format) {
    case "markdown":
      return postExcerpt(content.body);
    case "text":
      return content.body;
    case "deleted":
      return "[deleted]";
    case "html":
    case "bundle":
      return "Open the rendered document.";
  }
}
export function ForumFeedRow({
  post,
  vote,
  onVote,
  postHref,
  renderLink,
}: Readonly<{
  post: ForumPostRecord;
  vote: ForumVote | undefined;
  onVote(input: Readonly<{ postId: string; direction: 1 | -1 }>): void;
  postHref(postId: string): string;
  renderLink: ForumLinkRenderer;
}>) {
  return (
    <article {...stylex.props(feedStyles.row)}>
      <div {...stylex.props(feedStyles.up)}>
        <VoteButton
          direction={1}
          label={post.title}
          vote={vote}
          onVote={(direction) => onVote({ postId: post.id, direction })}
        />
      </div>
      <div {...stylex.props(feedStyles.rowContent)}>
        {renderLink({
          href: postHref(post.id),
          ...stylex.props(feedStyles.postLink),
          children: post.title,
        })}
        <Byline {...post} renderLink={renderLink} />
        <p {...stylex.props(feedStyles.excerpt)}>
          {contentExcerpt(post.content)}
        </p>
        {post.images?.map((image) => (
          <Fragment key={image.id}>
            {renderLink({
              href: postHref(post.id),
              children: (
                <img
                  src={image.src}
                  alt={image.alt}
                  loading="lazy"
                  {...stylex.props(styles.attachment)}
                />
              ),
            })}
          </Fragment>
        ))}
        {vote?.error && (
          <Alert tone="danger" announcement="assertive">
            {vote?.error}
          </Alert>
        )}
      </div>
      <div {...stylex.props(feedStyles.down)}>
        <span
          aria-label={`${post.score} points`}
          {...stylex.props(styles.score)}
        >
          {post.score}
        </span>
        <VoteButton
          direction={-1}
          label={post.title}
          vote={vote}
          onVote={(direction) => onVote({ postId: post.id, direction })}
        />
      </div>
    </article>
  );
}
